module.exports = __webpack_public_path__ + "img/administration.ae3d27d1.svg";